module.exports = __webpack_public_path__ + "static/media/pet3.95800f46.jpg";